import AboutSettings from './AboutSettings';

export default AboutSettings;
